<template>
  <div class="profile">
    <div>
      <div
        v-if="userRoleProfile.basic_info.is_active !== 1  && CompanyName === 'TestAdmit'"
        style="margin:20px auto"
        class="box-card"
      >
        <el-alert
          :title="$t('message.confirm_email')"
          type="warning"
          show-icon
          :closable="false"
          style="text-align:left"
        >
          <el-button type="success" size="small" @click="sendVerifyEmail">
            {{ $t("message.confirm_your_email") }}
          </el-button>
        </el-alert>
      </div>
      <el-card class="box-card" style="margin:20px auto">
        <div class="titleStyle">
          <h1 class="primaryColor" style="font-size: 30px;">
            {{ $t("userProfile.title") }}
          </h1>
          <el-divider></el-divider>
        </div>

        <el-tabs v-model="activeName">
          <el-tab-pane
            :label="$t('userProfile.basicInfo')"
            name="info"
            v-if="dispatchFinished"
          >
            <BasicInfo></BasicInfo>
          </el-tab-pane>
          <el-tab-pane
            :label="$t('userProfile.studentInfo')"
            name="student"
            v-if="dispatchFinished && roles.includes('student')"
          >
            <StudentInfo></StudentInfo>
          </el-tab-pane>
        </el-tabs>
        <template v-if="CompanyName === 'TestAdmit'">
          <div style="margin-top:20px">
            <Balance />
          </div>
          <div style="margin-top:20px">
            <InviteCard />
          </div>
        </template>
      </el-card>
      <div style="margin:20px auto" v-if="CompanyName === 'TestAdmit'">
        <el-button type="info" @click="deleteUser">Delete my account!</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import User from "@/apis/user.js";
import BasicInfo from "@/components/userProfile/BasicInfo";
import StudentInfo from "@/components/userProfile/StudentInfo";
import Balance from "@/views/ielts/transcript/components/balance";
import InviteCard from "@/components/InviteCard";

export default {
  components: {
    BasicInfo,
    StudentInfo,
    Balance,
    InviteCard
  },
  data() {
    return {
      activeName: "info",
      roles: [],
      isActive: false,
      dispatchFinished: false
    };
  },
  async mounted() {
    if (this.$route.query.username) {
      this.$router.push({
        path: `userProfile?username=${this.$route.query.username}`
      });
    }
    await this.initialProfile();
  },
  methods: {
    async initialProfile() {
      this.dispatchFinished = false;
      await this.$store.dispatch("profile/userRoleProfile");
      this.roles = this.userRoleProfile.basic_info.all_roles;
      this.isActive = Boolean(this.userRoleProfile.basic_info.is_active);
      this.dispatchFinished = true;
    },
    async sendVerifyEmail() {
      await User.sendVerifyEmail();
      this.$message({
        message: "Success!",
        type: "success"
      });
    },
    deleteUser() {
      this.$confirm("Your account is about to be deleted. This action is irreversible. Do you wish to continue?", "Warning", {
        confirmButtonText: "Yes, I want to delete this account.",
        cancelButtonText: "Cancel, I clicked by mistake.",
        type: "warning"
      })
        .then(async () => {
          await User.deleteUser(this.userRoleProfile.basic_info.id);
          this.$message({
            type: "success",
            message: "Success!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Cancelled"
          });
        });
    }
  },
  computed: {
    ...mapState("profile", ["userRoleProfile"])
  }
};
</script>

<style scoped>
.titleLine {
  text-align: center;
}
.titleStyle {
  display: block;
  overflow: auto;
}
.primaryColor {
  color: var(--themeColor);
}
.box-card {
  display: inline-block;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}
.profile {
  text-align: center;
}
</style>
